import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TaskListModule } from './task-list/task-list.module';
import { TaskListComponent } from './task-list/task-list.component';
import { TaskEditComponent } from './task-edit/task-edit.component';
import { TaskEditModule } from './task-edit/task-edit.module';
import { TaskLeadEditModule } from './task-lead-edit/task-lead-edit.module';

@NgModule({
  imports: [
    CommonModule,
    TaskListModule,
    TaskEditModule,
    TaskLeadEditModule,
    RouterModule.forChild([
      {
        path: "",
        children: [
          {
            path: "",
            redirectTo: "list",
            pathMatch: "full"
          },
          {
            path: "create",
            component: TaskEditComponent
          },
          {
            path: "edit/:id",
            component: TaskEditComponent
          },
          {
            path: "list",
            component: TaskListComponent
          }
        ]
      }
    ])
  ]
})
export class TaskModule { }
